import { render, staticRenderFns } from "./ModelManagerDetailsComponent.vue?vue&type=template&id=01d41176&"
import script from "./ModelManagerDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./ModelManagerDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports